<div [class]="styles.container()">
  @for (item of renderedMenuItems(); track item.route) {
    <div
      [class]="getClassesForMenuItem(item).item()"
      role="button"
      tabindex="0"
      [routerLink]="item.route"
    >
      <edu-icon [icon]="item.icon" />
      <span>{{ item.label | transloco }}</span>
      @if (item.indicatorIcon; as indicatorIcon) {
        <edu-icon [icon]="indicatorIcon" iconClasses="text-warning text-sm" />
      }
    </div>
  }
</div>
